import { APP_NAME_IRT_IN_IFRAME, Events } from '@shared/constants';
import { isNotDefined, keepTrying } from '@/utils';
import { postMessageParent } from '@/utils/lib/iFrameHelper';

function sendMessageToIFrameParent(): void {
  const msg = { type: Events.Ready, sender: APP_NAME_IRT_IN_IFRAME };
  postMessageParent(msg);
}

keepTrying(() => !isNotDefined(window))
  .then(sendMessageToIFrameParent)
  .catch(() => {
    throw new Error('Cannot send message to the Iframe parent because "window" is not defined');
  });
